import { useState, useEffect } from 'react';

interface ScrollPosition {
  x: number;
  y: number;
  direction: 'up' | 'down' | 'none';
}

export function useScrollPosition(throttleMs = 100): ScrollPosition {
  const [position, setPosition] = useState<ScrollPosition>({
    x: 0,
    y: 0,
    direction: 'none',
  });

  useEffect(() => {
    let lastY = 0;
    let rafId: number;
    let lastTime = 0;

    const handleScroll = () => {
      const now = Date.now();
      if (now - lastTime < throttleMs) return;
      lastTime = now;

      rafId = requestAnimationFrame(() => {
        const y = window.scrollY;
        const direction = y > lastY ? 'down' : y < lastY ? 'up' : 'none';
        lastY = y;
        setPosition({ x: window.scrollX, y, direction });
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(rafId);
    };
  }, [throttleMs]);

  return position;
}
